import * as React from "react";
import { Contents } from "../../../../Resoures/Contents";
import { OldNewTrustWizard, steppers } from "../Resource/Contents";
import { ClientType } from "./ClientType/ClientType";
import { Urls } from "../../../../Urls";
import { StepType } from "../../../../../Shared/Process/Process/Process";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { ClientDetails } from "./ClientDetails/ClientDetails";
import { AddClientAction } from "../Actions/AddClientAction";
import { NetworkHistoryModel } from "../../../../../../Wrap/Models/Models/Network/NetworkHistoryModel";
import { CompanySummary } from "../../../../../../Wrap/Models/Models/Company/CompanySummary";
import { Adviser } from "../../../../../../Wrap/Models/Domains/Adviser/Adviser";
import { TrustDetail } from "./Organisation/TrustDetail";
import { TrustMember } from "./Organisation/TrustMember";
import { Organisation } from "../../../../../../Wrap/Models/Models/Customer/Organisation";
import { CustomerType } from "../../../../../../Wrap/Constants/Enums/Customer/CustomerType";
import { WizardComponent } from "../../../../../Shared/Process/WizardComponent";
import { Prospect } from "../../../../../../Wrap/Models/Models/Customer/Prospect";
import { HierarchyIdHelper } from "../../../../../Shared/Common/HierarchyIdHelper";
import { HierarchyLevelName } from "../../../../../../Wrap/Constants/Enums/HierarchyLevelName";
import { FullClientDetailHelper } from "../../Common/FullClientDetail/FullClientDetailHelper";
import { PhysicalAddressType } from "../../../../../../Wrap/Constants/Enums/Customer/PhysicalAddressType";
import { ServiceProposition } from "../../../../../../Wrap/Constants/Enums/ServiceProposition";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";
import { FATCABusinessType } from "../../../../../../Wrap/Constants/Enums/Customer/FATCABusinessType";
import { Lightbox } from "../../../../../../react-core/Html/Components/Lightbox";

export const enum Journey {
    Quote,
    NewBusiness,
    CreateAnotherClient,
    AddClient,
    NewTrust,
}
export interface IAddClientModel {
    CustomerType?: CustomerType;
    Prospect?: Prospect;
    Organisation?: Organisation;
    SelectedNetwork?: NetworkHistoryModel;
    SelectedFirm?: CompanySummary;
    SelectedFirmHierarchy?: string;
    SelectedAdviser?: Adviser;
    SelectedFirmProposition?: Array<ServiceProposition>;
}

export class AddClientWizard extends WizardComponent {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        super.componentDidMount();
        this.setState({ data: { CustomerType: CustomerType.NotSpecified }, isLoading: false });
    }
    onSubmit() {}

    onSubmitClient(from: number, journeyType: Journey) {
        const isPass = this.child[from]?.isValid();
        if (!isPass) {
            this.setState((preState) => ({ isShowErrorMsg: preState.errorMsg.length > 0 }));
        } else {
            this.setState({ isLoading: true });
            this.saveCustomer(journeyType);
        }
    }

    saveCustomer(journeyType: Journey) {
        if (this.state.data?.CustomerType == CustomerType.Individual && this.state.data.Prospect) {
            AddClientAction.submitClientDetails(this.state.data.Prospect, (data) => {
                this.navigateAfterSubmittion(journeyType, data);
            });
        } else if (
            (this.state.data?.CustomerType == CustomerType.CorporateTrust ||
                this.state.data?.CustomerType == CustomerType.Trust) &&
            this.state.data.Organisation
        ) {
            const _model: Organisation = this.state.data.Organisation;
            _model?.OrganisationMembers?.forEach((x) => {
                if (
                    FullClientDetailHelper.isSameAddress(
                        x?.Individual?.AddressDetails[0]?.Address,
                        x?.Individual?.AddressDetails[1]?.Address
                    )
                ) {
                    const index = x?.Individual?.AddressDetails.findIndex(
                        (y) =>
                            y.PhysicalAddressType == PhysicalAddressType.Postal ||
                            y.PhysicalAddressType == PhysicalAddressType.Registered
                    );
                    x?.Individual?.AddressDetails.splice(index, 1);
                }
            });

            AddClientAction.submitTrustDetail(_model, (data) => {
                this.navigateAfterSubmittion(journeyType, data);
            });
        }
    }

    saveInstruction(from: any, to: any, toUrl: any, params: any, stepLength: any) {
        this.setState({ onPosting: false });

        if (to == -1) {
            this.onExit();
        } else {
            if (
                (this.state.data?.CustomerType == CustomerType.CorporateTrust ||
                    this.state.data?.CustomerType == CustomerType.Trust) &&
                this.state.data.Organisation?.FATCABusinessType == FATCABusinessType.InvestmentBody &&
                from == 1 &&
                this.state.extraInfo?.showLightbox == false
            ) {
                this.setState({ extraInfo: { ...this.state.extraInfo, showLightbox: true } });
            } else {
                this.setState({ extraInfo: { ...this.state.extraInfo, showLightbox: false } });
                this.goToNextStep(toUrl, params);
            }
        }
    }

    private goToNextStep(toUrl, params) {
        Navigator.navigateTo(toUrl, {
            queryParamsObject: params,
            scrollAfterNavigating: true,
        });
    }

    customeRender() {
        if (!this.state.extraInfo?.showLightbox) {return null;}
        return (
            <Lightbox
                title=""
                show={this.state.extraInfo?.showLightbox}
                cssWrapper="is-default-lightbox"
                isClickOutsideClose={false}
                onClose={() => this.onStepperLeave(1, 2)}
            >
                <p>
                    An Entity Self Certification form will need to be completed and sent to us before we can activate
                    the new account. Once you have completed the wizard please go to the literature library and complete
                    the Entity Self Certification form. Once we have received the completed form the account will be
                    activated.
                </p>
                <button className="btn primary" onClick={() => this.onStepperLeave(1, 2)}>
                    OK
                </button>
            </Lightbox>
        );
    }

    private navigateAfterSubmittion(journeyType: Journey, data: any) {
        switch (journeyType) {
            case Journey.Quote:
                if (checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite))
                    {Navigator.navigateTo(Urls.get().QuoteWrapperSelection, {
                        scrollAfterNavigating: true,
                        queryParamsObject: { customerid: data.Id.toString(), isnewclient: true },
                    });}
                break;
            case Journey.NewBusiness:
                if (checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite))
                    {Navigator.navigateTo(Urls.get().FullClientDetail, {
                        scrollAfterNavigating: true,
                        queryParamsObject: { customerid: data.Id.toString(), isnewclient: true },
                    });}
                break;
            case Journey.CreateAnotherClient:
                this.setState({ data: { CustomerType: CustomerType.NotSpecified }, isLoading: false }, () => {
                    if (checkPermission(UserClaim.AdviserPortalNewQuoteNewBusinessReadWrite))
                        {Navigator.navigateTo(Urls.get().ClientType);}
                });
                break;
            case Journey.AddClient:
                if (checkPermission(UserClaim.AdviserPortalCustomerPartialAccessCanView))
                    {Navigator.navigateTo(
                        Urls.get().main.PortfolioDashboard({
                            hierarchyId: HierarchyIdHelper.toHierarchyIdString(HierarchyLevelName.Customer, data.Id),
                        }).activity
                    );}
                break;
            case Journey.NewTrust:
                if (checkPermission(UserClaim.AdviserPortalDluTrustCreateCanView))
                    {window.location.href = OldNewTrustWizard + `?customerid=${data.Id.toString()}`;}
                break;
        }
    }
    onCancel() {
        this.onExit();
    }

    onExit() {
        Navigator.navigateTo(Urls.get().main.Dashboard);
    }

    setStepperConfig() {
        this.stepperConfig = [
            {
                title: steppers.clientTypeSelection,
                url: Urls.get().ClientType,
                path: Contents.URLMap.clientType,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                component: <ClientType {...this.getStepProps(0)} />,
            },
        ];
        if (this.state.data?.CustomerType == CustomerType.Individual) {
            this.stepperConfig.push({
                title: steppers.clientDetails,
                url: Urls.get().ClientDetails,
                path: Contents.URLMap.clientDetails,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                type: StepType.Custom,
                component: (
                    <ClientDetails
                        {...this.getStepProps(1)}
                        onSubmit={(journeyType: Journey) => this.onSubmitClient(1, journeyType)}
                    />
                ),
            });
        }
        if (this.state.data?.CustomerType == CustomerType.Trust) {
            this.stepperConfig.push({
                title: "Trust detail",
                url: Urls.get().TrustDetail,
                path: Contents.URLMap.trustDetail,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <TrustDetail {...this.getStepProps(1)} />,
            });
            this.stepperConfig.push({
                title: "Trust member",
                url: Urls.get().TrustMember,
                path: Contents.URLMap.trustMember,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                type: StepType.Custom,
                component: (
                    <TrustMember
                        {...this.getStepProps(2)}
                        onSubmit={(journeyType: Journey) => this.onSubmitClient(2, journeyType)}
                        onPrevious={() => this.onStepperLeave(2, 1)}
                    />
                ),
            });
        }
        if (this.state.data?.CustomerType == CustomerType.CorporateTrust) {
            this.stepperConfig.push({
                title: "Corporate detail",
                url: Urls.get().CorporateDetail,
                path: Contents.URLMap.corporateDetail,
                onStepLeave: (from, to) => {
                    this.onStepperLeave(from, to);
                },
                component: <TrustDetail {...this.getStepProps(1)} />,
            });
            this.stepperConfig.push({
                title: "Corporate member",
                url: Urls.get().CorporateMember,
                path: Contents.URLMap.corporateMember,
                onStepLeave: (from, to) => this.onStepperLeave(from, to),
                type: StepType.Custom,
                component: (
                    <TrustMember
                        {...this.getStepProps(2)}
                        onSubmit={(journeyType: Journey) => this.onSubmitClient(2, journeyType)}
                        onPrevious={() => this.onStepperLeave(2, 1)}
                    />
                ),
            });
        }
    }

    setProcessProps() {
        const processProps = super.setProcessProps();
        processProps.processTitle = "Add new client";
        processProps.onSave = null;
        processProps.goBacktoFirst = true;
        return processProps;
    }
}
